/**
 * And empty object to reuse to prevent object recreation and re-rendering
 * @deprecated Do not use legacy components anymore.
 */
export var EMPTY_OBJECT = {};
// Freezing since altering this will alter it everywhere!
Object.freeze(EMPTY_OBJECT);
//# sourceMappingURL=EMPTY_OBJECT.js.map